export function getDVPPath(customerName, customerSurname, serialNum, brand, model, progressive) {
    const currentYear = new Date().getFullYear()
    const months = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"]
    const currentMonth = months[new Date().getMonth()]

    return `PDF/dvp/model/${currentYear}/${currentMonth}/DVP_${progressive}-${customerName}_${customerSurname}-${brand}_${model}-IMEI_${serialNum}.pdf`
}